import {ajaxRest} from './ajaxBase'

const CONTROLLER_PREFIX = 'system'

function getSystemSetting () {
  let p = new Promise((resolve, reject) => {
    let params
    params = {
      url: `/${CONTROLLER_PREFIX}/info`,
      method: 'GET',
      timeout: {client: 10 * 1000}
    }
    ajaxRest(params).then(data => {
      if (!data.data.edition) {
        data.data.edition = "Unknown" // Unknown, Standard, Professional
        data.data.limitation_validaty = true
        data.data.limitation = {
          'org': 5,
          'user': 10,
          'sketchboard_3d': 5,
          'sketchboard_2d': 10,
          'datasource': 20,
          'customized_logo': false
        }
      }
      resolve(data)
    }).catch(error => {
      reject(error)
    })
  })
  return p
}

function getVersionHistory (param) {
  let p = new Promise((resolve, reject) => {
    let params
    params = {
      url: `/${CONTROLLER_PREFIX}/versionHistory?${param}`,
      method: 'GET',
      timeout: {client: 10 * 1000}
    }
    ajaxRest(params).then(data => {
      resolve(data)
    }).catch(error => {
      reject(error)
    })
    // resolve({
    //   errCode: 0,
    //   data: [
    //     {version: '1.0.1', date: '', description: ''},
    //     {version: '1.0.2', date: '', description: ''},
    //     {version: '1.0.3', date: '', description: ''},
    //     {version: '1.0.4', date: '', description: ''}
    //   ]
    // })
  })
  return p
}

function getProductConfig (orgId) {
  let p = new Promise((resolve, reject) => {
    let orgIdParam = ''
    if (typeof orgId !== 'undefined') {
      orgIdParam = `org_id=${orgId}`
    }
    let params
    params = {
      url: `/${CONTROLLER_PREFIX}/productConfig?${orgIdParam}`,
      method: 'GET',
      timeout: {client: 10 * 1000}
    }
    ajaxRest(params).then(data => {
      // console.log('data', data)
      if (data.errCode === 0) {
        changeFavicon(data.data)
        resolve(data.data)
      }
    }).catch(error => {
      reject(error)
    })
  })
  return p
}

function changeFavicon (data) {
  var link = document.querySelector("link[rel~='icon']")
  if (!link) {
    link = document.createElement('link')
    link.rel = 'icon';
    document.getElementsByTagName('head')[0].appendChild(link)
  }
  link.href = data.product_favicon
  // modify title
  document.title = data.pageTitle || data.product_name
}

function reloadProductConfig() {
  // let fd = new FormData();
  // fd.append('org_id', orgId);
  // fd.append('path', 'assets/logo/' + name);
  // fd.append('content', content);
  let p = new Promise((resolve, reject) => {
    let params
    params = {
      url: `/${CONTROLLER_PREFIX}/gui/custom/reload`,
      method: 'POST',
      // data: fd,
      timeout: {client: 10 * 1000}
    }
    ajaxRest(params).then(data => {
      resolve(data)
    }).catch(error => {
      reject(error)
    })
  })
  return p
}

function deleteProductConfig(fileDir, fileName) {
  let fd = new FormData();
  fd.append('file_dir', fileDir);
  fd.append('file_name', fileName);
  // fd.append('content', content);
  let p = new Promise((resolve, reject) => {
    let params
    params = {
      url: `/${CONTROLLER_PREFIX}/gui/custom/logo`,
      method: 'DELETE',
      data: fd,
      timeout: {client: 10 * 1000}
    }
    ajaxRest(params).then(data => {
      resolve(data)
    }).catch(error => {
      reject(error)
    })
  })
  return p
}

export default {
  getSystemSetting,
  getVersionHistory,
  getProductConfig,
  reloadProductConfig,
  deleteProductConfig
}



// WEBPACK FOOTER //
// ./src/api/systemSettingAPI.js